"use client";

import { useFormValidation } from "@repo/lib/hooks/common";
import { AddressStepSkeleton, CheckoutAddress, CheckoutGuestShipping, CheckoutLogin, CheckoutPayment, Stepper } from "@repo/components";
import { INITIAL_ADDRESS_FORM_VALUES } from "@repo/constants/account";
import { CHECKOUT_STEPS } from "@repo/constants/checkout";
import { useCheckoutSteps } from "@repo/lib/hooks/checkout";
import cx from "classnames";
import { useCallback, useEffect, useState } from "react";
const CheckoutSteps = ({
  session,
  address,
  paymentMethods,
  locale,
  cart,
  cartRule
}) => {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const {
    handleCheckoutSignIn,
    isPending,
    activeStepper,
    completedSteps,
    handleAddressComplete,
    handleGuestSelection,
    handleStepChange
  } = useCheckoutSteps(session, cart);
  const {
    formValues,
    formErrors,
    setFormErrors,
    handleValidation
  } = useFormValidation(INITIAL_ADDRESS_FORM_VALUES);
  const handleSelectedAddress = useCallback(async address => {
    setSelectedAddress(address);
  }, []);
  useEffect(() => {
    // If no address is received from API. For Eg: User do not have the address or all addresses are deleted
    if (!Array.isArray(address?.content) || address.content.length === 0) {
      setSelectedAddress(null);
      return;
    }
    // Select the address based on user selection, if the user have selected default address for checkout
    const getSelectedAddress = address.content.find(item => item.defaultAddress === true);
    // Set the default addresss selected or first address selected
    setSelectedAddress(getSelectedAddress || address.content[0]);
  }, [address]);
  return <>
      <Stepper activeStepper={activeStepper} completedSteps={completedSteps} onStepChange={handleStepChange} data-sentry-element="Stepper" data-sentry-source-file="CheckoutSteps.jsx" />
      {activeStepper === CHECKOUT_STEPS.ACCOUNT && !session && <CheckoutLogin session={session} handleCheckoutSignIn={handleCheckoutSignIn} handleGuestSelection={handleGuestSelection} />}
      {activeStepper === CHECKOUT_STEPS.ADDRESS && <>
          {isPending ? <AddressStepSkeleton /> : <>
              {session ? <CheckoutAddress address={address} handleSelectedAddress={handleSelectedAddress} selectedAddress={selectedAddress} handleAddressComplete={handleAddressComplete} session={session} /> : <div className={cx({
          hidden: session
        })}>
                  <CheckoutGuestShipping handleAddressComplete={handleAddressComplete} formValues={formValues} formErrors={formErrors} setFormErrors={setFormErrors} handleValidation={handleValidation} setSelectedAddress={setSelectedAddress} />
                </div>}
            </>}
        </>}
      {activeStepper === CHECKOUT_STEPS.SHIPPING && <CheckoutPayment selectedAddress={selectedAddress} paymentMethods={paymentMethods} locale={locale} cart={cart} cartRule={cartRule} />}
    </>;
};
export default CheckoutSteps;